import { parse as PapaParse } from 'papaparse';

export interface ParseResult {
  data: Array<{
    [key: string]: string | number | boolean | null;
  }>;

  errors: Array<{
    type: string;
    code: string;
    message: string;
    row: number;
  }>;

  meta: {
    aborted: boolean;
    cursor: number;
    delimiter: string;
    fields: Array<string>;
    linebreak: string;
    truncated: boolean;
  };
}

export const csvFileToJSON = (file: File): Promise<ParseResult> => {
  return new Promise((resolve) => {
    PapaParse(file, {
      header: true,
      dynamicTyping: false,
      skipEmptyLines: true,
      complete: (results: unknown) => {
        console.log('🚀 ~ file: csv-to-json.ts:34 ~ returnnewPromise ~ results:', results);

        resolve(results as ParseResult);
      },
    });
  });
};
